var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DriverLogFactory } from '../framework/DriverLog';
import { State } from '../framework/State';
import { Timeouts } from '../framework/Timeouts';
import { UdpCommandSocket } from '../framework/UdpCommandSocket';
const modelInfo = [
    {
        isDecoder: true,
        isEncoder: false,
        modelId: '-NU2FVxso3ZqLjpSmXqj',
        modelName: 'D4100',
    },
    {
        isDecoder: true,
        isEncoder: false,
        modelId: '-NU2Fe2VnsmFGFlCahAF',
        modelName: 'D4200',
    },
    {
        isDecoder: true,
        isEncoder: false,
        modelId: '-NU2FiYWpJ0zu4J2dAi3',
        modelName: 'DuetD',
    },
    {
        isDecoder: true,
        isEncoder: false,
        modelId: '-NU2Fp825VSoeAOGv0_R',
        modelName: 'DuetD-2',
    },
    {
        isDecoder: false,
        isEncoder: true,
        modelId: '-NU2Fw14dqYv9qB6BXxd',
        modelName: 'DuetE',
        singleInputEncoderCode: 'HDMI',
    },
    {
        isDecoder: false,
        isEncoder: true,
        modelId: '-NU2G-fG2IE14LvcFFOp',
        modelName: 'DuetE-2',
    },
    {
        isDecoder: false,
        isEncoder: true,
        modelId: '-NU2G47q-XAUgAF6NK30',
        modelName: 'DuetE-WP',
        singleInputEncoderCode: 'HDMI',
    },
    {
        isDecoder: false,
        isEncoder: true,
        modelId: '-NU2G8TVRo6OVq6yVP1V',
        modelName: 'DuetE-WP-BT',
        singleInputEncoderCode: 'HDMI',
    },
    {
        isDecoder: false,
        isEncoder: true,
        modelId: '-NU2GCkAV9TKWuowR8cj',
        modelName: 'DuetE-WP-H',
        singleInputEncoderCode: 'HDMI',
    },
    {
        isDecoder: false,
        isEncoder: true,
        modelId: '-NU2GI-OulF6N9VvTac7',
        modelName: 'E-WP',
        singleInputEncoderCode: 'HDMI',
    },
    {
        isDecoder: false,
        isEncoder: true,
        modelId: '-NU2GNkJaYdSGsAzrma5',
        modelName: 'E-WP-H',
        singleInputEncoderCode: 'HDMI',
    },
    {
        isDecoder: false,
        isEncoder: true,
        modelId: '-NU2GYClhjXUzO0vLfuQ',
        modelName: 'E-WP-BT',
        singleInputEncoderCode: 'HDMI',
    },
    {
        isDecoder: false,
        isEncoder: true,
        modelId: '-NU2Gj-GWxpYIevXnOBW',
        modelName: 'E4100',
        singleInputEncoderCode: 'HDMI',
    },
    {
        isDecoder: false,
        isEncoder: true,
        modelId: '-NU2Gsv-r6x89SdopJnX',
        modelName: 'E4200',
    },
    // 5-series products
    { isDecoder: true, isEncoder: false, modelId: '-OLGC4v3oVdMkonikKPo', modelName: 'D5100' },
    { isDecoder: true, isEncoder: false, modelId: '-OLGC4weVFPE3mNtLlIj', modelName: 'D5200' },
    { isDecoder: true, isEncoder: false, modelId: '-OLGC4yDNZbAyTMMdyu6', modelName: 'DuetD5' },
    {
        isDecoder: false,
        isEncoder: true,
        modelId: '-OLGC4znRpPyDMLkVQ6R',
        modelName: 'DuetE5',
        singleInputEncoderCode: 'HDMI',
    },
    { isDecoder: false, isEncoder: true, modelId: '-OLGC50NHK2iVf4Jy2Va', modelName: 'DuetE5-WP' },
    {
        isDecoder: false,
        isEncoder: true,
        modelId: '-OLGC51wcGsQbKpMu-Pd',
        modelName: 'DuetE5-WP-BT',
    },
    {
        isDecoder: false,
        isEncoder: true,
        modelId: '-OLGC53mMAWVJd2JxIfJ',
        modelName: 'DuetE5-WP-H',
    },
    {
        isDecoder: false,
        isEncoder: true,
        modelId: '-OLGC55LS5Wl6q4jaP5S',
        modelName: 'E5-WP',
        singleInputEncoderCode: 'HDMI',
    },
    {
        isDecoder: false,
        isEncoder: true,
        modelId: '-OLGC56viIKj4wV-Ya6S',
        modelName: 'E5-WP-BT',
        singleInputEncoderCode: 'HDMI',
    },
    {
        isDecoder: false,
        isEncoder: true,
        modelId: '-OLGC58UlbYtZVoNeprs',
        modelName: 'E5-WP-H',
        singleInputEncoderCode: 'HDMI',
    },
    {
        isDecoder: false,
        isEncoder: true,
        modelId: '-OLGC5A3bBOQgdTWFnkG',
        modelName: 'E5100',
        singleInputEncoderCode: 'HDMI',
    },
    { isDecoder: false, isEncoder: true, modelId: '-OLGC5BcYIhIitHL6BY2', modelName: 'E5200' },
];
const seriesInfo = [
    {
        broadcastIp: '226.0.0.19',
        equipmentTypeId: '-NPrrY6eB7EkwX7N30Sj',
        key: 'series4',
        videoSignalType: 'visionaryAvoip',
    },
    {
        broadcastIp: '226.1.2.20',
        equipmentTypeId: '-ORMKoN7qD6Xb3JB1ZhF',
        key: 'series5',
        videoSignalType: 'visionaryAvoip5',
    },
];
function findModelInfoByModelName(modelName) {
    return modelInfo.find(m => m.modelName.toLowerCase() === modelName.toLowerCase());
}
function findModelInfoByModelId(modelId) {
    return modelInfo.find(m => m.modelId === modelId);
}
export function getDiscoveredEquipment(equipmentTypeId) {
    return __awaiter(this, void 0, void 0, function* () {
        const discoveryService = DiscoveryService.getDiscoveryService(equipmentTypeId);
        return discoveryService.getDiscoveredEquipment();
    });
}
export function getDiscoveryService(equipmentTypeId) {
    return DiscoveryService.getDiscoveryService(equipmentTypeId);
}
function parseResp(resp) {
    return Object.fromEntries((resp !== null && resp !== void 0 ? resp : '')
        .trim()
        .split('&')
        .filter(s => s.includes('='))
        .map(s => s.split('=')));
}
class DiscoveryService {
    constructor(seriesInfo) {
        this.seriesInfo = seriesInfo;
        this.devices = new State([]);
        this.discoveryIntervalMs = 30000;
        this.discoveryObservers = [];
        this.discoveryTimestamp = 0;
        this.driverDevices = {};
        this.driverUuid = 0;
        this.isDiscovering = false;
        this.timeouts = new Timeouts();
        this.discoveryTimeout = this.timeouts.create();
        this.logFactory = new DriverLogFactory('VisionarySolutions');
        this.log = this.logFactory.channel('DiscoveryService');
    }
    static getDiscoveryService(equipmentTypeId) {
        var _a;
        const info = (_a = seriesInfo.find(s => s.equipmentTypeId === equipmentTypeId)) !== null && _a !== void 0 ? _a : seriesInfo[0];
        let discoveryService = DiscoveryService.discoveryServices[info.key];
        if (discoveryService === undefined) {
            discoveryService = new DiscoveryService(info);
            DiscoveryService.discoveryServices[info.key] = discoveryService;
        }
        return discoveryService;
    }
    createUdpCommandSocket(options, emulatorKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const socket = new UdpCommandSocket(this.logFactory, options !== null && options !== void 0 ? options : {}, emulatorKey);
            yield socket.bind();
            return socket;
        });
    }
    discoverDevices() {
        return __awaiter(this, void 0, void 0, function* () {
            this.isDiscovering = true;
            const discoveryPromise = new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                const devices = [];
                const discoveryTasks = [];
                let isDoingDiscoveryTask = false;
                this.log.info(`discovering devices via udp`);
                // We don't need to use an emulator key for this udpSocket since we add the
                // simulated devices later.
                const options = { idleTimeoutMs: 0, port: 8001 };
                let tmpUdpSocket;
                try {
                    // This can fail if the provider doesn't support udp sockets, e.g., UI preview.
                    tmpUdpSocket = yield this.createUdpCommandSocket(options);
                }
                catch (_a) {
                    resolve(devices);
                }
                if (tmpUdpSocket !== undefined) {
                    const udpSocket = tmpUdpSocket;
                    const tags = ['get.devices', 'poll'];
                    yield this.udpSendMulticast(this.seriesInfo.broadcastIp, udpSocket, `QUERY.KEY=UNIT.ID`, tags, `UNIT.ID`, (ipAddress, params) => __awaiter(this, void 0, void 0, function* () {
                        const unitId = params['UNIT.ID'];
                        if (unitId === undefined) {
                            this.log.warning(`missing unit id`);
                            return;
                        }
                        // If the device is one for which we have an active driver, then ignore
                        // it. We will add it after UDP discovery has completed. This way we
                        // don't have to send unnecessary queries.
                        const driverDevice = Object.values(this.driverDevices).find(d => d.unitId === unitId);
                        if (driverDevice !== undefined)
                            return;
                        // Otherwise, poll the device for its information. We use a task queue
                        // to serialize the polls so we don't flood the network.
                        discoveryTasks.push(() => __awaiter(this, void 0, void 0, function* () {
                            // We use udp queries instead of http since they don't require auth
                            // credentials.
                            var _b;
                            const modelName = (_b = (yield this.udpGetKey(udpSocket, ipAddress, 'UNIT.MODEL', tags))) !== null && _b !== void 0 ? _b : 'unknown';
                            const modelInfo = findModelInfoByModelName(modelName);
                            if (modelInfo === undefined) {
                                this.log.warning(`unrecognized model: ${modelName}`);
                                return;
                            }
                            const serialNumber = yield this.udpGetKey(udpSocket, ipAddress, 'UNIT.SERIAL', tags);
                            if (serialNumber === undefined) {
                                this.log.warning(`missing serial number`);
                                return;
                            }
                            devices.push(Object.assign(Object.assign({ ipAddress, missingCount: 0 }, modelInfo), { serialNumber,
                                unitId }));
                        }));
                        if (!isDoingDiscoveryTask) {
                            isDoingDiscoveryTask = true;
                            for (let task = discoveryTasks.shift(); task !== undefined; task = discoveryTasks.shift()) {
                                yield task();
                            }
                            isDoingDiscoveryTask = false;
                        }
                    }), 5000);
                    udpSocket.close();
                    this.log.info(`discovery complete`);
                    resolve(devices);
                }
            }));
            const devices = yield discoveryPromise;
            this.discoveryTimestamp = Date.now();
            this.isDiscovering = false;
            // Add driver devices. This populates the info for devices we have as drivers so we don't
            // have to query them during discovery. It also accounts for simulated devices, which won't
            // respond to the multicast discovery command. We do this after the UDP multicast discovery
            // in case any devices have come online while we were waiting.
            for (const device of Object.values(this.driverDevices)) {
                devices.push(Object.assign(Object.assign({}, device), { missingCount: 0 }));
            }
            // UDP discovery can be unreliable, so if a device was previously detected and is now
            // missing, don't remove it right away. Wait until it hasn't shown up for several discovery
            // cycles before removing it.
            for (const device of this.devices.value) {
                const newDevice = devices.find(d => d.serialNumber === device.serialNumber);
                if (newDevice === undefined && device.missingCount < 3) {
                    devices.push(Object.assign(Object.assign({}, device), { missingCount: device.missingCount + 1 }));
                }
            }
            // Sort devices so object comparison in update works correctly.
            devices.sort((a, b) => a.serialNumber.localeCompare(b.serialNumber));
            this.log.info(`discovered devices = ${JSON.stringify(devices, null, 4)}`);
            // Reschedule discovery if there are registered drivers.
            if (Object.keys(this.driverDevices).length > 0) {
                this.discoveryTimeout.set(() => __awaiter(this, void 0, void 0, function* () { return this.discoverDevices(); }), this.discoveryIntervalMs);
            }
            // Notify devices observers.
            this.devices.update(devices);
            // Notify observers waiting for discovery to complete.
            const discoveryObservers = [...this.discoveryObservers];
            this.discoveryObservers.length = 0;
            discoveryObservers.forEach(o => o());
        });
    }
    getDevices() {
        return __awaiter(this, void 0, void 0, function* () {
            if (Date.now() - this.discoveryTimestamp < this.discoveryIntervalMs) {
                return this.devices.value;
            }
            return new Promise((resolve, reject) => {
                this.discoveryObservers.push(() => resolve(this.devices.value));
            });
        });
    }
    getDiscoveredEquipment() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isDiscovering && !this.discoveryTimeout.isRunning) {
                this.discoverDevices(); // don't await
            }
            const devices = yield this.getDevices();
            return Object.fromEntries(Object.entries(devices)
                .filter(([key, device]) => !device.simulated)
                .map(([key, device]) => [
                `a${key}`,
                {
                    equipmentTypeId: this.seriesInfo.equipmentTypeId,
                    ipAddress: device.ipAddress,
                    modelNumber: device.modelId,
                    serialNumber: device.serialNumber,
                    type: 'visionarySolutions',
                    unitId: device.unitId,
                },
            ]));
        });
    }
    getUnitId(uuid) {
        var _a;
        return (_a = this.driverDevices[uuid]) === null || _a === void 0 ? void 0 : _a.unitId;
    }
    register(device) {
        const uuid = (this.driverUuid++).toString();
        this.driverDevices[uuid] = device;
        if (!this.isDiscovering && !this.discoveryTimeout.isRunning) {
            this.discoverDevices(); // don't await
        }
        return uuid;
    }
    udpGetKey(udpSocket, address, key, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = yield this.udpSendCommand(udpSocket, address, `QUERY.KEY=${key}`, key, tags);
            return params[key];
        });
    }
    udpSendCommand(udpSocket, address, command, respMatch, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const resp = yield udpSocket.sendTo(address, 8000, `CMD=START&UNIT.ID=ALL&${command}&CMD=END`, command => command.address === address &&
                    command.command.includes('API.STATUS=SUCCESS') &&
                    command.command.includes(respMatch)
                    ? command.command
                    : undefined, tags, { retryAttempts: 3 });
                return parseResp(resp.command);
            }
            catch (error) {
                this.log.error(error);
                return {};
            }
        });
    }
    udpSendMulticast(ipAddress, udpSocket, command, tags, respMatch, onMatch, timeoutMs) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                const timeout = this.timeouts.create();
                const id = udpSocket.registerAsync({
                    match: command => (command.includes(respMatch) ? command : undefined),
                    callback: (command, address, port) => {
                        const params = parseResp(command);
                        onMatch === null || onMatch === void 0 ? void 0 : onMatch(address !== null && address !== void 0 ? address : '', params);
                        timeout.restart(timeoutMs);
                    },
                });
                timeout.set(() => {
                    udpSocket.unregisterAsync(id);
                    timeout.destroy();
                    resolve();
                }, timeoutMs);
                try {
                    yield udpSocket.sendToAsync(ipAddress, 8000, `CMD=START&UNIT.ID=ALL&${command}&CMD=END`, tags);
                }
                catch (error) {
                    this.log.error(error);
                }
            }));
        });
    }
    unregister(uuid) {
        const driverDevice = this.driverDevices[uuid];
        // Remove device from driverDevices.
        delete this.driverDevices[uuid];
        // Remove device from discovered devices.
        const serialNumber = driverDevice === null || driverDevice === void 0 ? void 0 : driverDevice.serialNumber;
        const devices = [...this.devices.value].filter(d => d.serialNumber !== serialNumber);
        this.devices.update(devices);
        // Stop the discovery timeout if there are no more registered devices.
        if (Object.keys(this.driverDevices).length <= 0 &&
            !this.isDiscovering &&
            this.discoveryTimeout.isRunning) {
            this.discoveryTimeout.clear();
        }
    }
    updateUnitId(uuid, unitId) {
        const device = this.driverDevices[uuid];
        if (device === undefined) {
            this.log.error(`failed updating unitId, no device for uuid = ${uuid}`);
            return;
        }
        device.unitId = unitId;
    }
}
DiscoveryService.discoveryServices = {};
export class VisionarySolutionsBase {
    constructor(http, state, log, framework) {
        this.http = http;
        this.state = state;
        this.log = log;
        this.framework = framework;
        this.numRetries = 3;
        this.password = 'admin';
        this.retryDelayMs = 500;
        this.timeouts = new Timeouts();
        this.username = 'admin';
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.detected = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c, _d;
                const detected = { videoInputs: [] };
                const devices = yield this.discoveryService.getDevices();
                for (const device of devices) {
                    if (device.isEncoder) {
                        (_a = detected.videoInputs) === null || _a === void 0 ? void 0 : _a.push({
                            code: device.serialNumber,
                            external: true,
                            name: `${device.unitId} (${device.ipAddress})`,
                            signalType: (_c = (_b = this.seriesInfo) === null || _b === void 0 ? void 0 : _b.videoSignalType) !== null && _c !== void 0 ? _c : 'visionaryAvoip',
                        });
                    }
                }
                (_d = detected.videoInputs) === null || _d === void 0 ? void 0 : _d.push({
                    code: 'LOGO',
                    external: false,
                    name: 'Logo',
                });
                return detected;
            }),
            hasControl: (config) => __awaiter(this, void 0, void 0, function* () { var _e, _f; return (_f = (_e = this.modelInfo) === null || _e === void 0 ? void 0 : _e.isDecoder) !== null && _f !== void 0 ? _f : false; }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const resp = yield this.getKey('UNIT.FIRMWARE', tags);
                return resp !== null && resp !== void 0 ? resp : 'unknown';
            }),
        };
        this.name = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                var _g, _h;
                return (_h = this.discoveryService.getUnitId((_g = this.uuid) !== null && _g !== void 0 ? _g : '')) !== null && _h !== void 0 ? _h : 'unknown';
            }),
        };
        this.serialNumber = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                var _j, _k;
                return (_k = (_j = this.findDeviceByIpAddress(this.http.host)) === null || _j === void 0 ? void 0 : _j.serialNumber) !== null && _k !== void 0 ? _k : 'unknown';
            }),
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                var _l, _m, _o, _p, _q, _r, _s;
                if ((_l = this.modelInfo) === null || _l === void 0 ? void 0 : _l.isDecoder) {
                    const videoOutput = (_m = (yield this.getKey('VIDEO.OUTPUT', tags))) !== null && _m !== void 0 ? _m : 'unknown';
                    if (videoOutput === 'LOGO')
                        return 'LOGO';
                    const streamHost = (_o = (yield this.getKey('STREAM.HOST', tags))) !== null && _o !== void 0 ? _o : 'unknown';
                    const encoder = this.findDeviceByIpAddress(streamHost);
                    return (_p = encoder === null || encoder === void 0 ? void 0 : encoder.serialNumber) !== null && _p !== void 0 ? _p : 'unknown';
                }
                else {
                    if (key === 'STREAM') {
                        if (((_q = this.modelInfo) === null || _q === void 0 ? void 0 : _q.singleInputEncoderCode) == undefined) {
                            return (_r = (yield this.getKey('STREAM.VIDEO', tags))) !== null && _r !== void 0 ? _r : 'unknown';
                        }
                        else {
                            return this.modelInfo.singleInputEncoderCode;
                        }
                    }
                    else {
                        return (_s = (yield this.getKey('VIDEO.HDMI_OUT', tags))) !== null && _s !== void 0 ? _s : 'unknown';
                    }
                }
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                var _t, _u, _v;
                this.state.busy.update(true);
                this.framework.suspendPolling(10000);
                if ((_t = this.modelInfo) === null || _t === void 0 ? void 0 : _t.isDecoder) {
                    if (value === 'LOGO') {
                        yield this.setKey('VIDEO.OUTPUT', 'LOGO', tags);
                    }
                    else {
                        const videoOutput = yield this.getKey('VIDEO.OUTPUT', tags);
                        if (videoOutput !== 'NORMAL') {
                            yield this.setKey('VIDEO.OUTPUT', 'NORMAL', tags);
                        }
                        const encoder = this.findDeviceBySerialNumber(value);
                        if (encoder === undefined) {
                            this.log.warning(`videoMatrixRoutes.set: missing device ${key}`);
                            value = (_u = this.state.videoMatrixRoutes.values[key]) !== null && _u !== void 0 ? _u : 'unknown';
                        }
                        else {
                            if (!encoder.isEncoder) {
                                this.log.warning(`stream host is not an encoder`);
                            }
                            yield this.setKeys([
                                ['STREAM.HOST', encoder.ipAddress],
                                ['STREAM.CONNECT', 'TRUE'],
                            ], tags);
                        }
                    }
                }
                else {
                    if (key === 'STREAM') {
                        if (((_v = this.modelInfo) === null || _v === void 0 ? void 0 : _v.singleInputEncoderCode) == undefined) {
                            yield this.setKey('STREAM.VIDEO', value, tags);
                        }
                        else {
                            // nop
                        }
                    }
                    else {
                        yield this.setKey('VIDEO.HDMI_OUT', value, tags);
                    }
                }
                this.busyTimeout.set(() => this.state.busy.update(false), 10000);
                return value;
            }),
        };
        // polling
        this.polls = [
            {
                controls: ['videoMatrixRoutes'],
                intervalMs: 5000,
            },
            {
                function: () => __awaiter(this, void 0, void 0, function* () {
                    const unitId = yield this.getKey('UNIT.ID', ['poll', 'get.unitId']);
                    if (unitId === undefined) {
                        this.log.warning(`failed getting unit`);
                    }
                    else if (this.uuid === undefined) {
                        this.log.error(`uuid is undefined`);
                    }
                    else {
                        if (unitId !== this.discoveryService.getUnitId(this.uuid)) {
                            this.discoveryService.updateUnitId(this.uuid, unitId);
                            this.state.name.update(unitId);
                        }
                    }
                }),
                intervalMs: 12000,
            },
        ];
        this.busyTimeout = this.timeouts.create();
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
            if (this.devicesSubscriptionId !== undefined) {
                this.discoveryService.devices.unsubscribe(this.devicesSubscriptionId);
                this.devicesSubscriptionId = undefined;
            }
            if (this.uuid !== undefined) {
                this.discoveryService.unregister(this.uuid);
            }
        });
    }
    onInitialize(credentials, config) {
        var _a, _b, _c, _d, _e, _f, _g;
        return __awaiter(this, void 0, void 0, function* () {
            this.username = (_a = credentials === null || credentials === void 0 ? void 0 : credentials.username) !== null && _a !== void 0 ? _a : 'admin';
            this.password = (_b = credentials === null || credentials === void 0 ? void 0 : credentials.password) !== null && _b !== void 0 ? _b : 'admin';
            try {
                const auth = btoa(`${this.username}:${this.password}`);
                const resp = yield this.http.request('post', '/cgi-bin/wapi.cgi', {
                    data: `CMD=START&UNIT.ID=ALL&UNIT.FU=TRUE&CMD=END`,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        Authorization: `Basic ${auth}`,
                    },
                    tags: ['initialize', 'set.identify'],
                });
                if (resp.status !== 200) {
                    return resp.status === 401 ? 'authFailed' : 'verifyFailed';
                }
            }
            catch (error) {
                return 'connectFailed';
            }
            const detectedModelName = (_c = (yield this.getKey('UNIT.MODEL', ['initialize', 'get.modelNumber']))) !== null && _c !== void 0 ? _c : 'unknown';
            this.modelInfo = findModelInfoByModelId((_d = config.modelNumber) !== null && _d !== void 0 ? _d : 'unknown');
            const specifiedModelName = (_f = (_e = this.modelInfo) === null || _e === void 0 ? void 0 : _e.modelName) !== null && _f !== void 0 ? _f : 'unknown';
            if (this.modelInfo === undefined) {
                this.log.error(`no modelInfo entry for modelNumber: ${config.modelNumber}`);
                return 'verifyFailed';
            }
            this.seriesInfo = seriesInfo.find(s => s.equipmentTypeId === config.equipmentType);
            if (this.seriesInfo === undefined) {
                this.log.error(`no seriesInfo entry for equipmentTypeId: ${config.equipmentType}`);
                return 'verifyFailed';
            }
            if (detectedModelName.toLowerCase() !== specifiedModelName.toLowerCase()) {
                this.log.warning(`model specified in mira portal (${specifiedModelName}) does not match device (${detectedModelName})`);
                return 'verifyFailed';
            }
            const serialNumber = yield this.getKey('UNIT.SERIAL', ['initialize', 'get.serialNumber']);
            if (serialNumber === undefined) {
                this.log.warning(`no serial number for device`);
                return 'verifyFailed';
            }
            const unitId = yield this.getKey('UNIT.ID', ['initialize', 'get.unitId']);
            if (unitId === undefined) {
                this.log.warning(`no unit id for device`);
                return 'verifyFailed';
            }
            if (this.uuid !== undefined) {
                this.log.error(`expected uuid to be undefined`);
            }
            this.uuid = this.discoveryService.register(Object.assign(Object.assign({}, this.modelInfo), { ipAddress: this.http.host, serialNumber, simulated: (_g = config.simulate) !== null && _g !== void 0 ? _g : false, unitId }));
            this.devicesSubscriptionId = this.discoveryService.devices.subscribe(() => __awaiter(this, void 0, void 0, function* () {
                if (this.framework.phase === 'controlling') {
                    this.framework.changePhase('configuring');
                }
            }));
            return 'connected';
        });
    }
    // other class methods
    findDeviceByIpAddress(ipAddress) {
        return this.discoveryService.devices.value.find(d => d.ipAddress === ipAddress);
    }
    findDeviceBySerialNumber(serialNumber) {
        return this.discoveryService.devices.value.find(d => d.serialNumber === serialNumber);
    }
    getKey(key, tags) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let numAttempts = 0;
            do {
                if (numAttempts > 0) {
                    yield this.timeouts.delay(this.retryDelayMs);
                    this.log.warning(`retrying`);
                }
                const params = yield this.post(`QUERY.KEY=${key}`, tags);
                if (((_a = params['API.STATUS']) === null || _a === void 0 ? void 0 : _a.startsWith('SUCCESS')) && params[key] !== undefined) {
                    return params[key];
                }
            } while (++numAttempts < this.numRetries);
            this.log.warning(`query ${key} failed`);
            return undefined;
        });
    }
    post(command, tags) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const auth = btoa(`${this.username}:${this.password}`);
            const resp = yield this.http.request('post', '/cgi-bin/wapi.cgi', {
                data: `CMD=START&UNIT.ID=ALL&${command}&CMD=END`,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: `Basic ${auth}`,
                },
                tags,
            });
            if (resp.status !== 200) {
                this.log.warning(`http error: ${resp.status}`);
                return {};
            }
            return parseResp((_a = resp.data) !== null && _a !== void 0 ? _a : '');
        });
    }
    setKey(key, value, tags) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let numAttempts = 0;
            do {
                if (numAttempts > 0) {
                    yield this.timeouts.delay(this.retryDelayMs);
                    this.log.warning(`retrying`);
                }
                const params = yield this.post(`${key}=${value}`, tags);
                if ((_a = params['API.STATUS']) === null || _a === void 0 ? void 0 : _a.startsWith('SUCCESS'))
                    return;
            } while (++numAttempts < this.numRetries);
            this.log.warning(`set ${key} failed`);
            return;
        });
    }
    setKeys(keys, tags) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let numAttempts = 0;
            do {
                if (numAttempts > 0) {
                    yield this.timeouts.delay(this.retryDelayMs);
                    this.log.warning(`retrying`);
                }
                const cmd = keys.map(([key, value]) => `${key}=${value}`).join('&');
                const params = yield this.post(cmd, tags);
                if ((_a = params['API.STATUS']) === null || _a === void 0 ? void 0 : _a.startsWith('SUCCESS'))
                    return;
            } while (++numAttempts < this.numRetries);
            this.log.warning(`set failed: ${JSON.stringify(keys)}`);
        });
    }
}
// static properties
VisionarySolutionsBase.driverType = 'httpDriver';
VisionarySolutionsBase.httpRequestOptions = {
    idleTimeoutMs: 0,
    prettyCommands: false,
    scheme: 'http',
};
